import React from 'react';
import HeadTittle from '../../../../components/HeadTittle';
import routes from '../../../../Routes/routes';
import DivContainerBody from '../../../../components/DivContainerBody';
import FieldsController from './FieldsController';
import ButtonIcon from "../../../../components/buttons/ButtonIcon";
import {AddIcon, CleanIcon} from "../../../../components/buttons/IconButtons";
import ButtonAction from "../../../../components/buttons/ButtonAction";
import CreateControllerApp from "./Functionality/CreateControllerApp";
import CommonControllerApp from "./Functionality/CommonControllerApp";
import {CustomTextField} from "../../../../components/CustomTextField";
import {Box} from "@mui/material";
import {CustomSelect} from "../../../../components/CustomSelect";
import DividerWithText from "../../../../components/DividerWithText";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CreateController = () => {
    const props = CommonControllerApp();

    const {
        t,
        controller,
        handleChange,
        emptyFields,
        allStatus,
        isValidIp,
        isValidOffset,
        handleClear
    } = props;

    const {
        getAllCardFormats,
        format,
        isValidFacilityCode,
        setIsValidFacilityCode,
        handleSubmit,
        handleChangeFormat,
        handleClearFormat
    } = CreateControllerApp(props);

    return (
        <>
            <HeadTittle
                name={'create'}
                link={routes.controller.list}
                divStack={
                    <ButtonIcon
                        id='btn_cc_clean'
                        Icon={CleanIcon}
                        onClick={() => {
                            handleClear();
                            handleClearFormat();
                        }}
                        title={'clear_instances'}
                        className={"btn-clean-secondary-600"}
                        tooltipPlacement={"right"}
                    />
                }>
                <ButtonAction
                    id='btn_cc_create'
                    name={'create'}
                    Icon={ AddIcon}
                    className='btn-icon-add'
                    onClick={() => handleSubmit()}
                />
            </HeadTittle>

            <DivContainerBody>
                <div className='row mt-4'>
                    <div className={"col-12 mb-4"}>
                        <DividerWithText title={t('data')} />
                    </div>
                    <FieldsController
                        controller={controller}
                        handleChange={handleChange}
                        emptyFields={emptyFields}
                        allStatus={allStatus}
                        isValidIp={isValidIp}
                        isValidOffset={isValidOffset}
                    />
                </div>
                <div className={"row"}>
                    <div className={"col-12 mb-4"}>
                        <DividerWithText title={t('card_format')} />
                    </div>
                    <div className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                        <CustomTextField id={"txt_cc_facility_code"}
                                         length={3}
                                         name={"facilityCode"}
                                         value={format?.facilityCode}
                                         trans={"facility_code"}
                                         type={"number"}
                                         onChange={(e) => {
                                             handleChangeFormat(e);
                                             if(format.isValidFacilityCode(e.target.value)) setIsValidFacilityCode(false);
                                             else setIsValidFacilityCode(true);
                                         }}
                                         required={true}
                                         emptyFields={emptyFields}
                                         helperText={"must_be_less_than_or_equal_to_255"}
                                         isValid={isValidFacilityCode}
                                         isValidText={"must_be_less_than_or_equal_to_255"}
                        />
                    </div>

                    <Box className='col-sm-12 col-md-6 col-xxl-6 col-lg-6 '>
                        <CustomSelect id={"slt_cc_format_id"}
                                      name={"formatId"}
                                      value={format?.formatId}
                                      keyName="id"
                                      onChange={handleChangeFormat}
                                      list={getAllCardFormats}
                                      trans={"format"}
                                      label={"lbl_cc_format_id"}
                                      required={true}
                                      emptyFields={emptyFields}
                                      showNoSelectionOption={false}
                        />
                    </Box>
                </div>
            </DivContainerBody>
        </>
    );
};

export default CreateController;
